'use strict';

const _ = require('lodash');
const { Component } = require('react');
const { object } = require('prop-types');

class Context extends Component {
  getChildContext() {
    return _.pick(this.props, _.keys(this.constructor.childContextTypes));
  }
  render() {
    return this.props.children;
  }
}
exports.Context = Context;

Context.childContextTypes = {
  readiness: object,
  history: object,
  window: object,
  document: object
};



// WEBPACK FOOTER //
// ./src/shared/context.js